const getJobCount = () => {
    if(document.querySelector('.stoof-jobs-menu-counter')){
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if(this.readyState == 4 && this.status == 200){
                const displayElement = document.querySelector('.stoof-jobs-menu-counter');
                displayElement.setAttribute('data-after', this.response);
            }
        }
        xhttp.open("POST", wp_environment.stoof_ajax_url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
        xhttp.send(`stoof_job_nonce=${wp_environment.stoof_job_nonce}&action=job_count`);
    }
}
export default  getJobCount;